module.exports = __webpack_public_path__ + "img/download.adea3d3f.svg";